import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

export type BannerType = "info" | "success" | "warning" | "error";

export interface Banner {
  // Repeat showBanner calls with the same id update in place instead of stacking.
  id: string;
  type: BannerType;
  message: string;
  closable?: boolean;
}

interface BannerState {
  banners: Banner[];
}

const initialState: BannerState = {
  banners: [],
};

const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    showBanner: (state, action: PayloadAction<Banner>) => {
      const existing = state.banners.findIndex((b) => b.id === action.payload.id);
      if (existing >= 0) {
        state.banners[existing] = action.payload;
      } else {
        state.banners.push(action.payload);
      }
    },
    dismissBanner: (state, action: PayloadAction<string>) => {
      state.banners = state.banners.filter((b) => b.id !== action.payload);
    },
    clearBanners: (state) => {
      state.banners = [];
    },
  },
});

export const { showBanner, dismissBanner, clearBanners } = bannerSlice.actions;
export default bannerSlice.reducer;
